import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const Serving: React.FC = () => {
    return (
        <section className="serving-bg">
            <div className="container lg:container md:mx-auto">
                <div className="serving overflow-hidden relative">
                    <div className="row grid md:grid-cols-12">
                        <div className="md:col-start-0 lg:col-start-4 md:col-span-12 lg:col-span-6">
                            <div className="text-center serving-content relative z-[1]">
                                <h2
                                    className="mb-4 fs-xl text-primary"
                                    data-aos="fade-up"
                                    data-aos-duration={1000}
                                    data-aos-delay={100}
                                >
                                    We Deliver Industry-Specific Solutions
                                </h2>
                                <p className="mb-6 " data-aos="fade-up" data-aos-duration={1000} data-aos-delay={200}>
                                    Our team builds digital solutions designed around each industry’s unique workflows and
                                    regulatory needs.
                                </p>
                                <div
                                    className="grid grid-cols-3 items-start sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 lg:mb-[30px] md:mb-[20px]"
                                    data-aos="fade-up"
                                    data-aos-duration={1000}
                                    data-aos-delay={250}
                                >
                                    <div className="flex justify-between  flex-col   border-r-[#3C4561] border-r pr-[30px] sm:pl-0  lg:pl-0 sm:pr-0 lg:pr-[30px] sm:pb-5 lg:pb-0 sm:border-r-0 md:border-r lg:border-r ">
                                        <p className="text-lg xl:h-[170px] lg:h-[210px] md:h-auto h-auto font-semibold mb-0  sm:text-base md:text-lg text-[#D7DEE5]">
                                            Built with real <br className="hidden lg:block" />
                                            workloads and <br className="hidden lg:block" /> real industry{' '}
                                            <br className="hidden lg:block" />
                                            needs in mind.
                                        </p>
                                    </div>
                                    <div className="flex justify-between  flex-col  px-[30px] border-r-[#3C4561] border-r  sm:pb-5 lg:pb-0 sm:px-0 lg:px-[30px] sm:border-r-0 md:border-r lg:border-r">
                                        <p className="text-lg xl:h-[170px] lg:h-[210px] md:h-auto h-auto font-semibold  mb-0  sm:text-base md:text-lg text-[#D7DEE5]">
                                            Experience across <br className="hidden lg:block" />
                                            10+ industries, <br className="hidden lg:block" />
                                            from startups to <br className="hidden lg:block" />
                                            large enterprises.
                                        </p>
                                    </div>

                                    <div className="flex justify-between pl-[30px] flex-col sm:pb-5 lg:pb-0 sm:px-0 md:pl-[30px] ">
                                        <p className="text-lg  font-semibold mb-0  sm:text-base md:text-lg text-[#D7DEE5]">
                                            AI & automation <br className="hidden lg:block" />
                                            solutions shaped <br className="hidden lg:block" />
                                            by sector-level <br className="hidden lg:block" />
                                            challenges.
                                        </p>
                                    </div>
                                </div>
                                <div className="btn-mask" data-aos="fade-up" data-aos-duration={1000} data-aos-delay={300}>
                                    <Link href="/contact-us" className="btn btn-primary">
                                        Talk to Our Expert
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="serving-logos">
                        <Image
                            src="/img/img-serving.webp"
                            width={1073}
                            height={503}
                            alt="img-serving-bg"
                            className="img-serving-bg hidden lg:block"
                            loading="lazy"
                        />
                        <Image
                            src="/img/blue-lines-tablet.webp"
                            width={594}
                            height={745}
                            alt="img-serving-bg"
                            className="img-serving-bg hidden md:block lg:hidden"
                            loading="lazy"
                        />
                        <Image
                            src="/img/blue-lines-mobile.webp"
                            width={594}
                            height={745}
                            alt="img-serving-bg"
                            className="img-serving-bg block md:hidden"
                            loading="lazy"
                        />
                        <div className="serving__logo serving__logo1 mw_move_y" data-aos="zoom-in" data-aos-duration={1000}>
                            <Image src="/img/icons/tabler-icon-dollar.svg" alt="icon-dollar" height={36} width={36} />
                        </div>
                        <div
                            className="serving__logo serving__logo2 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={100}
                        >
                            <Image
                                src="/img/icons/tabler-icon-vacuum-cleaner.svg"
                                height={36}
                                width={36}
                                alt="icon-vacuum-cleaner"
                            />
                        </div>
                        <div
                            className="serving__logo serving__logo3 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={200}
                        >
                            <Image src="/img/icons/tabler-icon-luggage.svg" height={36} width={36} alt="icon-luggage" />
                        </div>
                        <div
                            className="serving__logo serving__logo4 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={300}
                        >
                            <Image src="/img/icons/tabler-icon-marketplace.svg" height={36} width={36} alt="icon-marketplace" />
                        </div>
                        <div
                            className="serving__logo serving__logo5 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={100}
                        >
                            <Image src="/img/icons/tabler-icon-open-book.svg" height={36} width={36} alt="icon-open-book" />
                        </div>
                        <div
                            className="serving__logo serving__logo6 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={200}
                        >
                            <Image src="/img/icons/tabler-icon-building.svg" height={36} width={36} alt="icon-building" />
                        </div>
                        <div
                            className="serving__logo serving__logo7 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={300}
                        >
                            <Image
                                src="/img/icons/tabler-icon-american-football.svg"
                                height={36}
                                width={36}
                                alt="icon-football"
                            />
                        </div>
                        <div
                            className="serving__logo serving__logo8 mw_move_y"
                            data-aos="zoom-in"
                            data-aos-duration={1000}
                            data-aos-delay={100}
                        >
                            <Image src="/img/icons/tabler-icon-settings.svg" height={36} width={36} alt="icon-setting" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Serving;
